// socketSlice.js
import { createAction } from '@reduxjs/toolkit';

export const connect = createAction('socket/connect', function prepare(url) {
    return { payload: { url } };
});
export const disconnect = createAction('socket/disconnect');
export const sendMessage = createAction('socket/sendMessage', function prepare(message) {
    return { payload: message };
});
export const socketConnected = createAction('socket/connected');
export const socketDisconnected = createAction('socket/disconnected');
export const socketError = createAction('socket/error', function prepare(error) {
    return { payload: error };
});
